import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function matrixScaleDimensionsBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  const dimensions = rawField.dimensions && !Array.isArray(rawField.dimensions) ? rawField.dimensions : undefined

  return {
    dimensions: [
      {
        type: 'RatingField',
        label: '项目',
        maximumRatingsDisplayText: dimensions?.maximumRatingsDisplayText ?? '非常满意',
        minimumRatingsDisplayText: dimensions?.minimumRatingsDisplayText ?? '非常不满意',
        rangeMin: 1,
        ratingMax: 5,
        ratingType: 'star',
        position: 0,
      },
    ],
  }
}
